import React, { useState, useRef, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import Form, {
  Item,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { resetPassword } from "../../api/auth";
import "./style.scss";

// const notificationText = 'We\'ve sent a link to reset your password. Check your inbox.';

export default function ResetPasswordForm() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const formData = useRef({});

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { email } = formData.current;
      setLoading(true);

      const result = await resetPassword(email);
      setLoading(false);

      if (result.isOk) {
        history.push("/login");
        notify(
          "We've sent a link to reset your password. Check your inbox.",
          "success",
          2500
        );
      } else {
        notify(result.message, "error", 2000);
      }
    },
    [history]
  );

  return (
    <form className={"login-form"} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading} labelLocation="top">
        <Item
          dataField={"email"}
          editorType={"dxTextBox"}
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="Email is required" />
          <EmailRule message="Email is invalid" />
        </Item>
        <ButtonItem cssClass="button-rounded mt-3">
          <ButtonOptions
            elementAttr={submitButtonAttributes}
            width={"100%"}
            type={"default"}
            stylingMode="outlined"
            useSubmitBehavior={true}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={"24px"} height={"24px"} visible={true} />
              ) : (
                "Reset my password"
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
        <Item>
          <div className={"login-link text-center"}>
            Return to <Link to={"/login"}>Sign In</Link>
          </div>
        </Item>
        {/* <Item>
          <div className={"login-link text-center"}>
            Return to <Link to={"/change-password/123"}>Change password</Link>
          </div>
        </Item> */}
      </Form>
    </form>
  );
}

const emailEditorOptions = { placeholder: "Email", mode: "email" };
const submitButtonAttributes = { class: "submit-button" };
